<template>
    <div data-testid="step-waitingForPicture" class="container">
        <h1 class="container__standard-header">
            {{ $t(`${TRANSLATION_KEY}.personalDataHeader`) }}
        </h1>
        <p class="container__subheader t-center t-bold">
            {{ $t(`${TRANSLATION_KEY}.waitingForPictureParagraph`) }}
        </p>
        <div class="row" :style="{ textAlign: 'center', marginTop: '-15px' }">
            <img
                cy-data="blackout"
                src="@/assets/loading-icon.gif"
                alt="loading icon"
            />
        </div>
        <div class="row row--waiting-for-the-picture">
            <NamedButton
                :disabled="!isUploaded"
                class="button width-for-button"
            >
                {{ $t(`${TRANSLATION_KEY}.next`) }}
            </NamedButton>
        </div>
        <!-- <div class="row row--resend-sms-again">
      <button type="button" class="resend-code fs-12" @click="backStep">
        {{ $t(`${TRANSLATION_KEY}.didntGetSms`) + " &raquo;" }}
      </button>
    </div> -->
        <div class="row row--information-about-refresh-website">
            <div class="row--info">
                <div class="image-wrapper">
                    <img src="@/assets/info.png" alt="info icon" />
                </div>
                <span class="fs-12">
                    {{
                        $t(
                            `${TRANSLATION_KEY}.informationAboutReloadingWebsite`
                        )
                    }}
                </span>
            </div>
            <div class="fs-12">
                {{ $t(`${TRANSLATION_KEY}.sendImageLater`) }}
                <SubmitButton
                    data-testid="btn-waitingForPicture-skip"
                    class="link"
                    :action="Action.ABORT_MOBILE"
                    cy-data="abort"
                >
                    {{ $t(`${TRANSLATION_KEY}.continueManually`) + ' »' }}
                </SubmitButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import NamedButton from '@/components/basic/buttons/NamedButton.vue';
import SubmitButton from '@/components/basic/buttons/SubmitButton.vue';
import { Action } from '@/constants/ajax';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import {
    SET_PROGRESS,
    SET_FORM_DATA,
    SET_GLOBAL_ERROR,
    SET_STEP,
    SET_LOCK,
} from '@/constants/mutation-types';
import { useRouter } from 'vue-router';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';

export default defineComponent({
    name: 'WaitingForPicture',
    components: {
        NamedButton,
        SubmitButton,
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const TRANSLATION_KEY = 'steps.WaitingForPicture';

        const status = ref(true);
        const forceLoopStop = ref(false);
        const isUploaded = ref(false);

        const ActionRef = Action;

        const checkWaitStatus = async () => {
            try {
                while (status.value && !forceLoopStop.value) {
                    const response = await store.state.ajaxService.runAction(
                        Action.CHECK_IF_DESKTOP_CAN_PROCEED,
                        {}
                    );
                    status.value = response.isDesktopWaiting;

                    if (response.isDesktopWaiting === false) {
                        forceLoopStop.value = true;

                        if (response.dataContent) {
                            store.commit(SET_FORM_DATA, response.dataContent);
                            const journeyId = response.dataContent.journeyId;
                            const backendUrl = response.dataContent.backendUrl;
                            const gbgToken = response.dataContent.gbgToken;
                            const skipHybridUpload =
                                response.dataContent.skipHybridUpload;

                            if (journeyId) {
                                fetch(
                                    `${backendUrl}idscanenterprisesvc/journey/get?journeyId=${journeyId}`,
                                    {
                                        headers: { Authorization: gbgToken },
                                    }
                                )
                                    .then((response: any) => {
                                        response.json().then((data: any) => {
                                            store.state.clientIdData =
                                                data.ProcessedDocuments;
                                            store.state.isSubheaderVisible = true;
                                            const journeyStatus =
                                                data.HighLevelResult.toLowerCase();
                                            store.state.isLocked = '';

                                            if (journeyStatus === 'passed') {
                                                router.push({
                                                    name: 'uploadSucceeded',
                                                });
                                            } else {
                                                router.push({
                                                    name: 'uploadFailed',
                                                });
                                            }
                                        });
                                    })
                                    .catch(() => {
                                        router.push({ name: 'uploadFailed' });
                                    });
                            } else if (skipHybridUpload == true) {
                                router.push({ name: 'personalDataConfirm' });
                            }
                        }
                        // await store.state.navigationService.goToRoute(response.next);
                    }
                    await UtilityHelper.sleep(5000);
                }
            } catch (e: any) {
                store.commit(SET_GLOBAL_ERROR, e.message);

                if (e.restart) {
                    store.commit(SET_STEP, 'restart');
                    store.state.ajaxService.restart();
                    try {
                        await store.state.navigationService.goToRoute(
                            'restart'
                        );
                    } catch (err: any) {
                        console.error(err);
                    }
                }

                await UtilityHelper.sleep(1000);
                store.commit(SET_LOCK, false);
            }
        };

        const backStep = () => {
            store.state.navigationService.goToRoute('mobileSms');
        };

        onMounted(() => {
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.WAITING_FOR_MOBILE);
            checkWaitStatus();
        });

        onBeforeUnmount(() => {
            forceLoopStop.value = true;
        });

        return {
            TRANSLATION_KEY,
            isUploaded,
            Action: ActionRef,
            backStep,
        };
    },
});
</script>
